/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BatchClaimPostPaymentRequest } from '../models';
// @ts-ignore
import type { BatchClaimPostPaymentResponse } from '../models';
// @ts-ignore
import type { BatchClaimPostPaymentValidationResponse } from '../models';
// @ts-ignore
import type { BatchPostPaymentSearchParams } from '../models';
// @ts-ignore
import type { Claim } from '../models';
// @ts-ignore
import type { ClaimCoveragesResponse } from '../models';
// @ts-ignore
import type { ClaimERASummary } from '../models';
// @ts-ignore
import type { ClaimPatch } from '../models';
// @ts-ignore
import type { ClaimPaymentPostInput } from '../models';
// @ts-ignore
import type { ClaimResponseDraftDelete } from '../models';
// @ts-ignore
import type { ClaimResponseDraftSave } from '../models';
// @ts-ignore
import type { ClaimResponseOperations } from '../models';
// @ts-ignore
import type { ClaimResubmitRequest } from '../models';
// @ts-ignore
import type { ClaimSearch } from '../models';
// @ts-ignore
import type { ClaimSubmissionResponse } from '../models';
// @ts-ignore
import type { ClaimVoidRequest } from '../models';
// @ts-ignore
import type { ClaimWithPatientDetails } from '../models';
// @ts-ignore
import type { ClaimWriteOffRequest } from '../models';
// @ts-ignore
import type { ClaimWriteOffResponse } from '../models';
// @ts-ignore
import type { GetClaims200Response } from '../models';
// @ts-ignore
import type { GetPaymentReconciliationByClaimId200Response } from '../models';
// @ts-ignore
import type { GetPostPaymentHistory200Response } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { OperationType } from '../models';
// @ts-ignore
import type { PaginatedDraftResponse } from '../models';
// @ts-ignore
import type { PatientControlNumberResponse } from '../models';
// @ts-ignore
import type { PaymentReconciliationSource } from '../models';
// @ts-ignore
import type { PostPaymentDraft } from '../models';
// @ts-ignore
import type { PrimaryClaimSubmitRequest } from '../models';
// @ts-ignore
import type { SecondaryClaimSubmitRequest } from '../models';
/**
 * FHIRClaimApi - axios parameter creator
 * @export
 */
export const FHIRClaimApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} batchId 
         * @param {string} reason 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelClaimBatchPostPayment: async (batchId: string, reason: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchId' is not null or undefined
            assertParamExists('cancelClaimBatchPostPayment', 'batchId', batchId)
            // verify required parameter 'reason' is not null or undefined
            assertParamExists('cancelClaimBatchPostPayment', 'reason', reason)
            const localVarPath = `/api/v1/fhir/claim/batch/postPayment/{batchId}`
                .replace(`{${"batchId"}}`, encodeURIComponent(String(batchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * post payment for claims
         * @summary post payment for claims
         * @param {BatchClaimPostPaymentRequest} batchClaimPostPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClaimBatchPostPayment: async (batchClaimPostPaymentRequest: BatchClaimPostPaymentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchClaimPostPaymentRequest' is not null or undefined
            assertParamExists('createClaimBatchPostPayment', 'batchClaimPostPaymentRequest', batchClaimPostPaymentRequest)
            const localVarPath = `/api/v1/fhir/claim/batch/postPayment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchClaimPostPaymentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete the primary claim in draft state
         * @summary delete the primary claim in draft state
         * @param {string} claimId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClaim: async (claimId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimId' is not null or undefined
            assertParamExists('deleteClaim', 'claimId', claimId)
            const localVarPath = `/api/v1/fhir/claim/{claimId}`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete post payment draft
         * @summary Delete post payment draft
         * @param {string} claimId 
         * @param {ClaimResponseDraftDelete} claimResponseDraftDelete 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePostPaymentDraft: async (claimId: string, claimResponseDraftDelete: ClaimResponseDraftDelete, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimId' is not null or undefined
            assertParamExists('deletePostPaymentDraft', 'claimId', claimId)
            // verify required parameter 'claimResponseDraftDelete' is not null or undefined
            assertParamExists('deletePostPaymentDraft', 'claimResponseDraftDelete', claimResponseDraftDelete)
            const localVarPath = `/api/v1/fhir/claim/postPayment/{claimId}/draft`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claimResponseDraftDelete, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate patient control number for the claim filing
         * @summary Generate patient control number for the claim filing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateClaimPatientControlNumber: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/fhir/claim/patientControlNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get claim by claim id
         * @summary Get a claim by claim id
         * @param {string} claimId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaim: async (claimId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimId' is not null or undefined
            assertParamExists('getClaim', 'claimId', claimId)
            const localVarPath = `/api/v1/fhir/claim/{claimId}`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get coverages for the claim filing
         * @summary Get coverages for the claim filing
         * @param {string} [claimId] 
         * @param {string} [patientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimCoverages: async (claimId?: string, patientId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/fhir/claim/coverages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (claimId !== undefined) {
                localVarQueryParameter['claimId'] = claimId;
            }

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search claims
         * @summary Search claims
         * @param {ClaimSearch} claimSearch 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaims: async (claimSearch: ClaimSearch, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimSearch' is not null or undefined
            assertParamExists('getClaims', 'claimSearch', claimSearch)
            const localVarPath = `/api/v1/fhir/claim/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claimSearch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get claims by patient id
         * @param {string} patientId 
         * @param {string} guarantorId 
         * @param {string} [paymentReconciliationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimsByPatientId: async (patientId: string, guarantorId: string, paymentReconciliationId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getClaimsByPatientId', 'patientId', patientId)
            // verify required parameter 'guarantorId' is not null or undefined
            assertParamExists('getClaimsByPatientId', 'guarantorId', guarantorId)
            const localVarPath = `/api/v1/fhir/claim/patient/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (guarantorId !== undefined) {
                localVarQueryParameter['guarantorId'] = guarantorId;
            }

            if (paymentReconciliationId !== undefined) {
                localVarQueryParameter['paymentReconciliationId'] = paymentReconciliationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get paginated payment reconciliations by claim id
         * @summary Get paginated payment reconciliations by claim id
         * @param {string} claimId 
         * @param {PaymentReconciliationSource} source 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentReconciliationByClaimId: async (claimId: string, source: PaymentReconciliationSource, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimId' is not null or undefined
            assertParamExists('getPaymentReconciliationByClaimId', 'claimId', claimId)
            // verify required parameter 'source' is not null or undefined
            assertParamExists('getPaymentReconciliationByClaimId', 'source', source)
            const localVarPath = `/api/v1/fhir/claim/{claimId}/paymentreconciliation`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get payment summary from ERA
         * @summary get payment summary from ERA
         * @param {string} claimId 
         * @param {ClaimResponseOperations} claimResponseOperations 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentSummary: async (claimId: string, claimResponseOperations: ClaimResponseOperations, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimId' is not null or undefined
            assertParamExists('getPaymentSummary', 'claimId', claimId)
            // verify required parameter 'claimResponseOperations' is not null or undefined
            assertParamExists('getPaymentSummary', 'claimResponseOperations', claimResponseOperations)
            const localVarPath = `/api/v1/fhir/claim/postPayment/{claimId}/eraSummary`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claimResponseOperations, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get post payment draft
         * @summary Get post payment draft
         * @param {string} claimId 
         * @param {OperationType} [operation] 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostPaymentDraft: async (claimId: string, operation?: OperationType, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimId' is not null or undefined
            assertParamExists('getPostPaymentDraft', 'claimId', claimId)
            const localVarPath = `/api/v1/fhir/claim/postPayment/{claimId}/draft`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (operation !== undefined) {
                localVarQueryParameter['operation'] = operation;
            }

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get history of post payment for claims
         * @summary get history of post payment for claims
         * @param {BatchPostPaymentSearchParams} batchPostPaymentSearchParams 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostPaymentHistory: async (batchPostPaymentSearchParams: BatchPostPaymentSearchParams, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchPostPaymentSearchParams' is not null or undefined
            assertParamExists('getPostPaymentHistory', 'batchPostPaymentSearchParams', batchPostPaymentSearchParams)
            const localVarPath = `/api/v1/fhir/claim/batch/postPayment/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchPostPaymentSearchParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Patch a claim
         * @summary Patch a claim
         * @param {string} claimId 
         * @param {ClaimPatch} claimPatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchClaim: async (claimId: string, claimPatch: ClaimPatch, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimId' is not null or undefined
            assertParamExists('patchClaim', 'claimId', claimId)
            // verify required parameter 'claimPatch' is not null or undefined
            assertParamExists('patchClaim', 'claimPatch', claimPatch)
            const localVarPath = `/api/v1/fhir/claim/{claimId}`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claimPatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Write off claims that have payment posted. Supports single claim, multiple claims, account-level, or patient-level write-offs.
         * @summary Write off claims
         * @param {ClaimWriteOffRequest} claimWriteOffRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postClaimWriteOff: async (claimWriteOffRequest: ClaimWriteOffRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimWriteOffRequest' is not null or undefined
            assertParamExists('postClaimWriteOff', 'claimWriteOffRequest', claimWriteOffRequest)
            const localVarPath = `/api/v1/fhir/claim/writeOff`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claimWriteOffRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create payment posting or update claim status
         * @summary Create a payment posting
         * @param {string} claimId 
         * @param {ClaimPaymentPostInput} claimPaymentPostInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPaymentForClaim: async (claimId: string, claimPaymentPostInput: ClaimPaymentPostInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimId' is not null or undefined
            assertParamExists('postPaymentForClaim', 'claimId', claimId)
            // verify required parameter 'claimPaymentPostInput' is not null or undefined
            assertParamExists('postPaymentForClaim', 'claimPaymentPostInput', claimPaymentPostInput)
            const localVarPath = `/api/v1/fhir/claim/{claimId}/postPayment`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claimPaymentPostInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resubmit a denied or voided claim
         * @summary Resubmit a denied or voided claim
         * @param {string} claimId 
         * @param {ClaimResubmitRequest} claimResubmitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resubmitClaim: async (claimId: string, claimResubmitRequest: ClaimResubmitRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimId' is not null or undefined
            assertParamExists('resubmitClaim', 'claimId', claimId)
            // verify required parameter 'claimResubmitRequest' is not null or undefined
            assertParamExists('resubmitClaim', 'claimResubmitRequest', claimResubmitRequest)
            const localVarPath = `/api/v1/fhir/claim/{claimId}/resubmit`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claimResubmitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Save post payment draft
         * @summary Save post payment draft
         * @param {string} claimId 
         * @param {ClaimResponseDraftSave} claimResponseDraftSave 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePostPaymentDraft: async (claimId: string, claimResponseDraftSave: ClaimResponseDraftSave, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimId' is not null or undefined
            assertParamExists('savePostPaymentDraft', 'claimId', claimId)
            // verify required parameter 'claimResponseDraftSave' is not null or undefined
            assertParamExists('savePostPaymentDraft', 'claimResponseDraftSave', claimResponseDraftSave)
            const localVarPath = `/api/v1/fhir/claim/postPayment/{claimId}/draft`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claimResponseDraftSave, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * submit the primary claim
         * @summary submit the primary claim
         * @param {PrimaryClaimSubmitRequest} primaryClaimSubmitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitPrimaryClaim: async (primaryClaimSubmitRequest: PrimaryClaimSubmitRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'primaryClaimSubmitRequest' is not null or undefined
            assertParamExists('submitPrimaryClaim', 'primaryClaimSubmitRequest', primaryClaimSubmitRequest)
            const localVarPath = `/api/v1/fhir/claim/primary/submit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(primaryClaimSubmitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submit secondary claim
         * @summary Submit secondary claim
         * @param {string} claimId 
         * @param {SecondaryClaimSubmitRequest} secondaryClaimSubmitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitSecondaryClaim: async (claimId: string, secondaryClaimSubmitRequest: SecondaryClaimSubmitRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimId' is not null or undefined
            assertParamExists('submitSecondaryClaim', 'claimId', claimId)
            // verify required parameter 'secondaryClaimSubmitRequest' is not null or undefined
            assertParamExists('submitSecondaryClaim', 'secondaryClaimSubmitRequest', secondaryClaimSubmitRequest)
            const localVarPath = `/api/v1/fhir/claim/{claimId}/secondary/submit`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(secondaryClaimSubmitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * validate bulk post payment for claims
         * @summary validate bulk post payment for claims
         * @param {ClaimSearch} claimSearch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePostPayment: async (claimSearch: ClaimSearch, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimSearch' is not null or undefined
            assertParamExists('validatePostPayment', 'claimSearch', claimSearch)
            const localVarPath = `/api/v1/fhir/claim/batch/postPayment/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claimSearch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Void a claim
         * @summary Void a claim
         * @param {string} claimId 
         * @param {ClaimVoidRequest} claimVoidRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voidClaim: async (claimId: string, claimVoidRequest: ClaimVoidRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimId' is not null or undefined
            assertParamExists('voidClaim', 'claimId', claimId)
            // verify required parameter 'claimVoidRequest' is not null or undefined
            assertParamExists('voidClaim', 'claimVoidRequest', claimVoidRequest)
            const localVarPath = `/api/v1/fhir/claim/{claimId}/void`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claimVoidRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FHIRClaimApi - functional programming interface
 * @export
 */
export const FHIRClaimApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FHIRClaimApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} batchId 
         * @param {string} reason 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelClaimBatchPostPayment(batchId: string, reason: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelClaimBatchPostPayment(batchId, reason, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRClaimApi.cancelClaimBatchPostPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * post payment for claims
         * @summary post payment for claims
         * @param {BatchClaimPostPaymentRequest} batchClaimPostPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createClaimBatchPostPayment(batchClaimPostPaymentRequest: BatchClaimPostPaymentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchClaimPostPaymentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createClaimBatchPostPayment(batchClaimPostPaymentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRClaimApi.createClaimBatchPostPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * delete the primary claim in draft state
         * @summary delete the primary claim in draft state
         * @param {string} claimId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteClaim(claimId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteClaim(claimId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRClaimApi.deleteClaim']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete post payment draft
         * @summary Delete post payment draft
         * @param {string} claimId 
         * @param {ClaimResponseDraftDelete} claimResponseDraftDelete 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePostPaymentDraft(claimId: string, claimResponseDraftDelete: ClaimResponseDraftDelete, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePostPaymentDraft(claimId, claimResponseDraftDelete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRClaimApi.deletePostPaymentDraft']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate patient control number for the claim filing
         * @summary Generate patient control number for the claim filing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateClaimPatientControlNumber(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientControlNumberResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateClaimPatientControlNumber(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRClaimApi.generateClaimPatientControlNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get claim by claim id
         * @summary Get a claim by claim id
         * @param {string} claimId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClaim(claimId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Claim>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClaim(claimId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRClaimApi.getClaim']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get coverages for the claim filing
         * @summary Get coverages for the claim filing
         * @param {string} [claimId] 
         * @param {string} [patientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClaimCoverages(claimId?: string, patientId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClaimCoveragesResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClaimCoverages(claimId, patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRClaimApi.getClaimCoverages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search claims
         * @summary Search claims
         * @param {ClaimSearch} claimSearch 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClaims(claimSearch: ClaimSearch, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetClaims200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClaims(claimSearch, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRClaimApi.getClaims']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get claims by patient id
         * @param {string} patientId 
         * @param {string} guarantorId 
         * @param {string} [paymentReconciliationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClaimsByPatientId(patientId: string, guarantorId: string, paymentReconciliationId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClaimWithPatientDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClaimsByPatientId(patientId, guarantorId, paymentReconciliationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRClaimApi.getClaimsByPatientId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get paginated payment reconciliations by claim id
         * @summary Get paginated payment reconciliations by claim id
         * @param {string} claimId 
         * @param {PaymentReconciliationSource} source 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentReconciliationByClaimId(claimId: string, source: PaymentReconciliationSource, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPaymentReconciliationByClaimId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentReconciliationByClaimId(claimId, source, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRClaimApi.getPaymentReconciliationByClaimId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get payment summary from ERA
         * @summary get payment summary from ERA
         * @param {string} claimId 
         * @param {ClaimResponseOperations} claimResponseOperations 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentSummary(claimId: string, claimResponseOperations: ClaimResponseOperations, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClaimERASummary>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentSummary(claimId, claimResponseOperations, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRClaimApi.getPaymentSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get post payment draft
         * @summary Get post payment draft
         * @param {string} claimId 
         * @param {OperationType} [operation] 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPostPaymentDraft(claimId: string, operation?: OperationType, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedDraftResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPostPaymentDraft(claimId, operation, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRClaimApi.getPostPaymentDraft']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get history of post payment for claims
         * @summary get history of post payment for claims
         * @param {BatchPostPaymentSearchParams} batchPostPaymentSearchParams 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPostPaymentHistory(batchPostPaymentSearchParams: BatchPostPaymentSearchParams, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPostPaymentHistory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPostPaymentHistory(batchPostPaymentSearchParams, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRClaimApi.getPostPaymentHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Patch a claim
         * @summary Patch a claim
         * @param {string} claimId 
         * @param {ClaimPatch} claimPatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchClaim(claimId: string, claimPatch: ClaimPatch, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Claim>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchClaim(claimId, claimPatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRClaimApi.patchClaim']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Write off claims that have payment posted. Supports single claim, multiple claims, account-level, or patient-level write-offs.
         * @summary Write off claims
         * @param {ClaimWriteOffRequest} claimWriteOffRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postClaimWriteOff(claimWriteOffRequest: ClaimWriteOffRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimWriteOffResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postClaimWriteOff(claimWriteOffRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRClaimApi.postClaimWriteOff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create payment posting or update claim status
         * @summary Create a payment posting
         * @param {string} claimId 
         * @param {ClaimPaymentPostInput} claimPaymentPostInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPaymentForClaim(claimId: string, claimPaymentPostInput: ClaimPaymentPostInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Claim>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPaymentForClaim(claimId, claimPaymentPostInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRClaimApi.postPaymentForClaim']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resubmit a denied or voided claim
         * @summary Resubmit a denied or voided claim
         * @param {string} claimId 
         * @param {ClaimResubmitRequest} claimResubmitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resubmitClaim(claimId: string, claimResubmitRequest: ClaimResubmitRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimSubmissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resubmitClaim(claimId, claimResubmitRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRClaimApi.resubmitClaim']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Save post payment draft
         * @summary Save post payment draft
         * @param {string} claimId 
         * @param {ClaimResponseDraftSave} claimResponseDraftSave 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async savePostPaymentDraft(claimId: string, claimResponseDraftSave: ClaimResponseDraftSave, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostPaymentDraft>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.savePostPaymentDraft(claimId, claimResponseDraftSave, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRClaimApi.savePostPaymentDraft']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * submit the primary claim
         * @summary submit the primary claim
         * @param {PrimaryClaimSubmitRequest} primaryClaimSubmitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitPrimaryClaim(primaryClaimSubmitRequest: PrimaryClaimSubmitRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimSubmissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitPrimaryClaim(primaryClaimSubmitRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRClaimApi.submitPrimaryClaim']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Submit secondary claim
         * @summary Submit secondary claim
         * @param {string} claimId 
         * @param {SecondaryClaimSubmitRequest} secondaryClaimSubmitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitSecondaryClaim(claimId: string, secondaryClaimSubmitRequest: SecondaryClaimSubmitRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimSubmissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitSecondaryClaim(claimId, secondaryClaimSubmitRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRClaimApi.submitSecondaryClaim']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * validate bulk post payment for claims
         * @summary validate bulk post payment for claims
         * @param {ClaimSearch} claimSearch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validatePostPayment(claimSearch: ClaimSearch, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchClaimPostPaymentValidationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validatePostPayment(claimSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRClaimApi.validatePostPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Void a claim
         * @summary Void a claim
         * @param {string} claimId 
         * @param {ClaimVoidRequest} claimVoidRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voidClaim(claimId: string, claimVoidRequest: ClaimVoidRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimSubmissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voidClaim(claimId, claimVoidRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRClaimApi.voidClaim']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FHIRClaimApi - factory interface
 * @export
 */
export const FHIRClaimApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FHIRClaimApiFp(configuration)
    return {
        /**
         * 
         * @param {FHIRClaimApiCancelClaimBatchPostPaymentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelClaimBatchPostPayment(requestParameters: FHIRClaimApiCancelClaimBatchPostPaymentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelClaimBatchPostPayment(requestParameters.batchId, requestParameters.reason, options).then((request) => request(axios, basePath));
        },
        /**
         * post payment for claims
         * @summary post payment for claims
         * @param {FHIRClaimApiCreateClaimBatchPostPaymentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClaimBatchPostPayment(requestParameters: FHIRClaimApiCreateClaimBatchPostPaymentRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchClaimPostPaymentResponse> {
            return localVarFp.createClaimBatchPostPayment(requestParameters.batchClaimPostPaymentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * delete the primary claim in draft state
         * @summary delete the primary claim in draft state
         * @param {FHIRClaimApiDeleteClaimRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClaim(requestParameters: FHIRClaimApiDeleteClaimRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteClaim(requestParameters.claimId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete post payment draft
         * @summary Delete post payment draft
         * @param {FHIRClaimApiDeletePostPaymentDraftRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePostPaymentDraft(requestParameters: FHIRClaimApiDeletePostPaymentDraftRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePostPaymentDraft(requestParameters.claimId, requestParameters.claimResponseDraftDelete, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate patient control number for the claim filing
         * @summary Generate patient control number for the claim filing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateClaimPatientControlNumber(options?: RawAxiosRequestConfig): AxiosPromise<PatientControlNumberResponse> {
            return localVarFp.generateClaimPatientControlNumber(options).then((request) => request(axios, basePath));
        },
        /**
         * Get claim by claim id
         * @summary Get a claim by claim id
         * @param {FHIRClaimApiGetClaimRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaim(requestParameters: FHIRClaimApiGetClaimRequest, options?: RawAxiosRequestConfig): AxiosPromise<Claim> {
            return localVarFp.getClaim(requestParameters.claimId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get coverages for the claim filing
         * @summary Get coverages for the claim filing
         * @param {FHIRClaimApiGetClaimCoveragesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimCoverages(requestParameters: FHIRClaimApiGetClaimCoveragesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClaimCoveragesResponse>> {
            return localVarFp.getClaimCoverages(requestParameters.claimId, requestParameters.patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Search claims
         * @summary Search claims
         * @param {FHIRClaimApiGetClaimsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaims(requestParameters: FHIRClaimApiGetClaimsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetClaims200Response> {
            return localVarFp.getClaims(requestParameters.claimSearch, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get claims by patient id
         * @param {FHIRClaimApiGetClaimsByPatientIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimsByPatientId(requestParameters: FHIRClaimApiGetClaimsByPatientIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClaimWithPatientDetails>> {
            return localVarFp.getClaimsByPatientId(requestParameters.patientId, requestParameters.guarantorId, requestParameters.paymentReconciliationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get paginated payment reconciliations by claim id
         * @summary Get paginated payment reconciliations by claim id
         * @param {FHIRClaimApiGetPaymentReconciliationByClaimIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentReconciliationByClaimId(requestParameters: FHIRClaimApiGetPaymentReconciliationByClaimIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetPaymentReconciliationByClaimId200Response> {
            return localVarFp.getPaymentReconciliationByClaimId(requestParameters.claimId, requestParameters.source, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(axios, basePath));
        },
        /**
         * get payment summary from ERA
         * @summary get payment summary from ERA
         * @param {FHIRClaimApiGetPaymentSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentSummary(requestParameters: FHIRClaimApiGetPaymentSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClaimERASummary>> {
            return localVarFp.getPaymentSummary(requestParameters.claimId, requestParameters.claimResponseOperations, options).then((request) => request(axios, basePath));
        },
        /**
         * Get post payment draft
         * @summary Get post payment draft
         * @param {FHIRClaimApiGetPostPaymentDraftRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostPaymentDraft(requestParameters: FHIRClaimApiGetPostPaymentDraftRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedDraftResponse> {
            return localVarFp.getPostPaymentDraft(requestParameters.claimId, requestParameters.operation, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(axios, basePath));
        },
        /**
         * get history of post payment for claims
         * @summary get history of post payment for claims
         * @param {FHIRClaimApiGetPostPaymentHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostPaymentHistory(requestParameters: FHIRClaimApiGetPostPaymentHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetPostPaymentHistory200Response> {
            return localVarFp.getPostPaymentHistory(requestParameters.batchPostPaymentSearchParams, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Patch a claim
         * @summary Patch a claim
         * @param {FHIRClaimApiPatchClaimRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchClaim(requestParameters: FHIRClaimApiPatchClaimRequest, options?: RawAxiosRequestConfig): AxiosPromise<Claim> {
            return localVarFp.patchClaim(requestParameters.claimId, requestParameters.claimPatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Write off claims that have payment posted. Supports single claim, multiple claims, account-level, or patient-level write-offs.
         * @summary Write off claims
         * @param {FHIRClaimApiPostClaimWriteOffRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postClaimWriteOff(requestParameters: FHIRClaimApiPostClaimWriteOffRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClaimWriteOffResponse> {
            return localVarFp.postClaimWriteOff(requestParameters.claimWriteOffRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create payment posting or update claim status
         * @summary Create a payment posting
         * @param {FHIRClaimApiPostPaymentForClaimRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPaymentForClaim(requestParameters: FHIRClaimApiPostPaymentForClaimRequest, options?: RawAxiosRequestConfig): AxiosPromise<Claim> {
            return localVarFp.postPaymentForClaim(requestParameters.claimId, requestParameters.claimPaymentPostInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Resubmit a denied or voided claim
         * @summary Resubmit a denied or voided claim
         * @param {FHIRClaimApiResubmitClaimRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resubmitClaim(requestParameters: FHIRClaimApiResubmitClaimRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClaimSubmissionResponse> {
            return localVarFp.resubmitClaim(requestParameters.claimId, requestParameters.claimResubmitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Save post payment draft
         * @summary Save post payment draft
         * @param {FHIRClaimApiSavePostPaymentDraftRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePostPaymentDraft(requestParameters: FHIRClaimApiSavePostPaymentDraftRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostPaymentDraft> {
            return localVarFp.savePostPaymentDraft(requestParameters.claimId, requestParameters.claimResponseDraftSave, options).then((request) => request(axios, basePath));
        },
        /**
         * submit the primary claim
         * @summary submit the primary claim
         * @param {FHIRClaimApiSubmitPrimaryClaimRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitPrimaryClaim(requestParameters: FHIRClaimApiSubmitPrimaryClaimRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClaimSubmissionResponse> {
            return localVarFp.submitPrimaryClaim(requestParameters.primaryClaimSubmitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit secondary claim
         * @summary Submit secondary claim
         * @param {FHIRClaimApiSubmitSecondaryClaimRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitSecondaryClaim(requestParameters: FHIRClaimApiSubmitSecondaryClaimRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClaimSubmissionResponse> {
            return localVarFp.submitSecondaryClaim(requestParameters.claimId, requestParameters.secondaryClaimSubmitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * validate bulk post payment for claims
         * @summary validate bulk post payment for claims
         * @param {FHIRClaimApiValidatePostPaymentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePostPayment(requestParameters: FHIRClaimApiValidatePostPaymentRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchClaimPostPaymentValidationResponse> {
            return localVarFp.validatePostPayment(requestParameters.claimSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Void a claim
         * @summary Void a claim
         * @param {FHIRClaimApiVoidClaimRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voidClaim(requestParameters: FHIRClaimApiVoidClaimRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClaimSubmissionResponse> {
            return localVarFp.voidClaim(requestParameters.claimId, requestParameters.claimVoidRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FHIRClaimApi - interface
 * @export
 * @interface FHIRClaimApi
 */
export interface FHIRClaimApiInterface {
    /**
     * 
     * @param {FHIRClaimApiCancelClaimBatchPostPaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApiInterface
     */
    cancelClaimBatchPostPayment(requestParameters: FHIRClaimApiCancelClaimBatchPostPaymentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * post payment for claims
     * @summary post payment for claims
     * @param {FHIRClaimApiCreateClaimBatchPostPaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApiInterface
     */
    createClaimBatchPostPayment(requestParameters: FHIRClaimApiCreateClaimBatchPostPaymentRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchClaimPostPaymentResponse>;

    /**
     * delete the primary claim in draft state
     * @summary delete the primary claim in draft state
     * @param {FHIRClaimApiDeleteClaimRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApiInterface
     */
    deleteClaim(requestParameters: FHIRClaimApiDeleteClaimRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Delete post payment draft
     * @summary Delete post payment draft
     * @param {FHIRClaimApiDeletePostPaymentDraftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApiInterface
     */
    deletePostPaymentDraft(requestParameters: FHIRClaimApiDeletePostPaymentDraftRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Generate patient control number for the claim filing
     * @summary Generate patient control number for the claim filing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApiInterface
     */
    generateClaimPatientControlNumber(options?: RawAxiosRequestConfig): AxiosPromise<PatientControlNumberResponse>;

    /**
     * Get claim by claim id
     * @summary Get a claim by claim id
     * @param {FHIRClaimApiGetClaimRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApiInterface
     */
    getClaim(requestParameters: FHIRClaimApiGetClaimRequest, options?: RawAxiosRequestConfig): AxiosPromise<Claim>;

    /**
     * Get coverages for the claim filing
     * @summary Get coverages for the claim filing
     * @param {FHIRClaimApiGetClaimCoveragesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApiInterface
     */
    getClaimCoverages(requestParameters?: FHIRClaimApiGetClaimCoveragesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClaimCoveragesResponse>>;

    /**
     * Search claims
     * @summary Search claims
     * @param {FHIRClaimApiGetClaimsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApiInterface
     */
    getClaims(requestParameters: FHIRClaimApiGetClaimsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetClaims200Response>;

    /**
     * 
     * @summary Get claims by patient id
     * @param {FHIRClaimApiGetClaimsByPatientIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApiInterface
     */
    getClaimsByPatientId(requestParameters: FHIRClaimApiGetClaimsByPatientIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClaimWithPatientDetails>>;

    /**
     * Get paginated payment reconciliations by claim id
     * @summary Get paginated payment reconciliations by claim id
     * @param {FHIRClaimApiGetPaymentReconciliationByClaimIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApiInterface
     */
    getPaymentReconciliationByClaimId(requestParameters: FHIRClaimApiGetPaymentReconciliationByClaimIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetPaymentReconciliationByClaimId200Response>;

    /**
     * get payment summary from ERA
     * @summary get payment summary from ERA
     * @param {FHIRClaimApiGetPaymentSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApiInterface
     */
    getPaymentSummary(requestParameters: FHIRClaimApiGetPaymentSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClaimERASummary>>;

    /**
     * Get post payment draft
     * @summary Get post payment draft
     * @param {FHIRClaimApiGetPostPaymentDraftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApiInterface
     */
    getPostPaymentDraft(requestParameters: FHIRClaimApiGetPostPaymentDraftRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedDraftResponse>;

    /**
     * get history of post payment for claims
     * @summary get history of post payment for claims
     * @param {FHIRClaimApiGetPostPaymentHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApiInterface
     */
    getPostPaymentHistory(requestParameters: FHIRClaimApiGetPostPaymentHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetPostPaymentHistory200Response>;

    /**
     * Patch a claim
     * @summary Patch a claim
     * @param {FHIRClaimApiPatchClaimRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApiInterface
     */
    patchClaim(requestParameters: FHIRClaimApiPatchClaimRequest, options?: RawAxiosRequestConfig): AxiosPromise<Claim>;

    /**
     * Write off claims that have payment posted. Supports single claim, multiple claims, account-level, or patient-level write-offs.
     * @summary Write off claims
     * @param {FHIRClaimApiPostClaimWriteOffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApiInterface
     */
    postClaimWriteOff(requestParameters: FHIRClaimApiPostClaimWriteOffRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClaimWriteOffResponse>;

    /**
     * Create payment posting or update claim status
     * @summary Create a payment posting
     * @param {FHIRClaimApiPostPaymentForClaimRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApiInterface
     */
    postPaymentForClaim(requestParameters: FHIRClaimApiPostPaymentForClaimRequest, options?: RawAxiosRequestConfig): AxiosPromise<Claim>;

    /**
     * Resubmit a denied or voided claim
     * @summary Resubmit a denied or voided claim
     * @param {FHIRClaimApiResubmitClaimRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApiInterface
     */
    resubmitClaim(requestParameters: FHIRClaimApiResubmitClaimRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClaimSubmissionResponse>;

    /**
     * Save post payment draft
     * @summary Save post payment draft
     * @param {FHIRClaimApiSavePostPaymentDraftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApiInterface
     */
    savePostPaymentDraft(requestParameters: FHIRClaimApiSavePostPaymentDraftRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostPaymentDraft>;

    /**
     * submit the primary claim
     * @summary submit the primary claim
     * @param {FHIRClaimApiSubmitPrimaryClaimRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApiInterface
     */
    submitPrimaryClaim(requestParameters: FHIRClaimApiSubmitPrimaryClaimRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClaimSubmissionResponse>;

    /**
     * Submit secondary claim
     * @summary Submit secondary claim
     * @param {FHIRClaimApiSubmitSecondaryClaimRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApiInterface
     */
    submitSecondaryClaim(requestParameters: FHIRClaimApiSubmitSecondaryClaimRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClaimSubmissionResponse>;

    /**
     * validate bulk post payment for claims
     * @summary validate bulk post payment for claims
     * @param {FHIRClaimApiValidatePostPaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApiInterface
     */
    validatePostPayment(requestParameters: FHIRClaimApiValidatePostPaymentRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchClaimPostPaymentValidationResponse>;

    /**
     * Void a claim
     * @summary Void a claim
     * @param {FHIRClaimApiVoidClaimRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApiInterface
     */
    voidClaim(requestParameters: FHIRClaimApiVoidClaimRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClaimSubmissionResponse>;

}

/**
 * Request parameters for cancelClaimBatchPostPayment operation in FHIRClaimApi.
 * @export
 * @interface FHIRClaimApiCancelClaimBatchPostPaymentRequest
 */
export interface FHIRClaimApiCancelClaimBatchPostPaymentRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRClaimApiCancelClaimBatchPostPayment
     */
    readonly batchId: string

    /**
     * 
     * @type {string}
     * @memberof FHIRClaimApiCancelClaimBatchPostPayment
     */
    readonly reason: string
}

/**
 * Request parameters for createClaimBatchPostPayment operation in FHIRClaimApi.
 * @export
 * @interface FHIRClaimApiCreateClaimBatchPostPaymentRequest
 */
export interface FHIRClaimApiCreateClaimBatchPostPaymentRequest {
    /**
     * 
     * @type {BatchClaimPostPaymentRequest}
     * @memberof FHIRClaimApiCreateClaimBatchPostPayment
     */
    readonly batchClaimPostPaymentRequest: BatchClaimPostPaymentRequest
}

/**
 * Request parameters for deleteClaim operation in FHIRClaimApi.
 * @export
 * @interface FHIRClaimApiDeleteClaimRequest
 */
export interface FHIRClaimApiDeleteClaimRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRClaimApiDeleteClaim
     */
    readonly claimId: string
}

/**
 * Request parameters for deletePostPaymentDraft operation in FHIRClaimApi.
 * @export
 * @interface FHIRClaimApiDeletePostPaymentDraftRequest
 */
export interface FHIRClaimApiDeletePostPaymentDraftRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRClaimApiDeletePostPaymentDraft
     */
    readonly claimId: string

    /**
     * 
     * @type {ClaimResponseDraftDelete}
     * @memberof FHIRClaimApiDeletePostPaymentDraft
     */
    readonly claimResponseDraftDelete: ClaimResponseDraftDelete
}

/**
 * Request parameters for getClaim operation in FHIRClaimApi.
 * @export
 * @interface FHIRClaimApiGetClaimRequest
 */
export interface FHIRClaimApiGetClaimRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRClaimApiGetClaim
     */
    readonly claimId: string
}

/**
 * Request parameters for getClaimCoverages operation in FHIRClaimApi.
 * @export
 * @interface FHIRClaimApiGetClaimCoveragesRequest
 */
export interface FHIRClaimApiGetClaimCoveragesRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRClaimApiGetClaimCoverages
     */
    readonly claimId?: string

    /**
     * 
     * @type {string}
     * @memberof FHIRClaimApiGetClaimCoverages
     */
    readonly patientId?: string
}

/**
 * Request parameters for getClaims operation in FHIRClaimApi.
 * @export
 * @interface FHIRClaimApiGetClaimsRequest
 */
export interface FHIRClaimApiGetClaimsRequest {
    /**
     * 
     * @type {ClaimSearch}
     * @memberof FHIRClaimApiGetClaims
     */
    readonly claimSearch: ClaimSearch

    /**
     * 
     * @type {number}
     * @memberof FHIRClaimApiGetClaims
     */
    readonly pgNum?: number

    /**
     * 
     * @type {number}
     * @memberof FHIRClaimApiGetClaims
     */
    readonly pgSize?: number
}

/**
 * Request parameters for getClaimsByPatientId operation in FHIRClaimApi.
 * @export
 * @interface FHIRClaimApiGetClaimsByPatientIdRequest
 */
export interface FHIRClaimApiGetClaimsByPatientIdRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRClaimApiGetClaimsByPatientId
     */
    readonly patientId: string

    /**
     * 
     * @type {string}
     * @memberof FHIRClaimApiGetClaimsByPatientId
     */
    readonly guarantorId: string

    /**
     * 
     * @type {string}
     * @memberof FHIRClaimApiGetClaimsByPatientId
     */
    readonly paymentReconciliationId?: string
}

/**
 * Request parameters for getPaymentReconciliationByClaimId operation in FHIRClaimApi.
 * @export
 * @interface FHIRClaimApiGetPaymentReconciliationByClaimIdRequest
 */
export interface FHIRClaimApiGetPaymentReconciliationByClaimIdRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRClaimApiGetPaymentReconciliationByClaimId
     */
    readonly claimId: string

    /**
     * 
     * @type {PaymentReconciliationSource}
     * @memberof FHIRClaimApiGetPaymentReconciliationByClaimId
     */
    readonly source: PaymentReconciliationSource

    /**
     * 
     * @type {number}
     * @memberof FHIRClaimApiGetPaymentReconciliationByClaimId
     */
    readonly pgNum?: number

    /**
     * 
     * @type {number}
     * @memberof FHIRClaimApiGetPaymentReconciliationByClaimId
     */
    readonly pgSize?: number
}

/**
 * Request parameters for getPaymentSummary operation in FHIRClaimApi.
 * @export
 * @interface FHIRClaimApiGetPaymentSummaryRequest
 */
export interface FHIRClaimApiGetPaymentSummaryRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRClaimApiGetPaymentSummary
     */
    readonly claimId: string

    /**
     * 
     * @type {ClaimResponseOperations}
     * @memberof FHIRClaimApiGetPaymentSummary
     */
    readonly claimResponseOperations: ClaimResponseOperations
}

/**
 * Request parameters for getPostPaymentDraft operation in FHIRClaimApi.
 * @export
 * @interface FHIRClaimApiGetPostPaymentDraftRequest
 */
export interface FHIRClaimApiGetPostPaymentDraftRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRClaimApiGetPostPaymentDraft
     */
    readonly claimId: string

    /**
     * 
     * @type {OperationType}
     * @memberof FHIRClaimApiGetPostPaymentDraft
     */
    readonly operation?: OperationType

    /**
     * 
     * @type {number}
     * @memberof FHIRClaimApiGetPostPaymentDraft
     */
    readonly pgNum?: number

    /**
     * 
     * @type {number}
     * @memberof FHIRClaimApiGetPostPaymentDraft
     */
    readonly pgSize?: number
}

/**
 * Request parameters for getPostPaymentHistory operation in FHIRClaimApi.
 * @export
 * @interface FHIRClaimApiGetPostPaymentHistoryRequest
 */
export interface FHIRClaimApiGetPostPaymentHistoryRequest {
    /**
     * 
     * @type {BatchPostPaymentSearchParams}
     * @memberof FHIRClaimApiGetPostPaymentHistory
     */
    readonly batchPostPaymentSearchParams: BatchPostPaymentSearchParams

    /**
     * 
     * @type {number}
     * @memberof FHIRClaimApiGetPostPaymentHistory
     */
    readonly pgNum?: number

    /**
     * 
     * @type {number}
     * @memberof FHIRClaimApiGetPostPaymentHistory
     */
    readonly pgSize?: number
}

/**
 * Request parameters for patchClaim operation in FHIRClaimApi.
 * @export
 * @interface FHIRClaimApiPatchClaimRequest
 */
export interface FHIRClaimApiPatchClaimRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRClaimApiPatchClaim
     */
    readonly claimId: string

    /**
     * 
     * @type {ClaimPatch}
     * @memberof FHIRClaimApiPatchClaim
     */
    readonly claimPatch: ClaimPatch
}

/**
 * Request parameters for postClaimWriteOff operation in FHIRClaimApi.
 * @export
 * @interface FHIRClaimApiPostClaimWriteOffRequest
 */
export interface FHIRClaimApiPostClaimWriteOffRequest {
    /**
     * 
     * @type {ClaimWriteOffRequest}
     * @memberof FHIRClaimApiPostClaimWriteOff
     */
    readonly claimWriteOffRequest: ClaimWriteOffRequest
}

/**
 * Request parameters for postPaymentForClaim operation in FHIRClaimApi.
 * @export
 * @interface FHIRClaimApiPostPaymentForClaimRequest
 */
export interface FHIRClaimApiPostPaymentForClaimRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRClaimApiPostPaymentForClaim
     */
    readonly claimId: string

    /**
     * 
     * @type {ClaimPaymentPostInput}
     * @memberof FHIRClaimApiPostPaymentForClaim
     */
    readonly claimPaymentPostInput: ClaimPaymentPostInput
}

/**
 * Request parameters for resubmitClaim operation in FHIRClaimApi.
 * @export
 * @interface FHIRClaimApiResubmitClaimRequest
 */
export interface FHIRClaimApiResubmitClaimRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRClaimApiResubmitClaim
     */
    readonly claimId: string

    /**
     * 
     * @type {ClaimResubmitRequest}
     * @memberof FHIRClaimApiResubmitClaim
     */
    readonly claimResubmitRequest: ClaimResubmitRequest
}

/**
 * Request parameters for savePostPaymentDraft operation in FHIRClaimApi.
 * @export
 * @interface FHIRClaimApiSavePostPaymentDraftRequest
 */
export interface FHIRClaimApiSavePostPaymentDraftRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRClaimApiSavePostPaymentDraft
     */
    readonly claimId: string

    /**
     * 
     * @type {ClaimResponseDraftSave}
     * @memberof FHIRClaimApiSavePostPaymentDraft
     */
    readonly claimResponseDraftSave: ClaimResponseDraftSave
}

/**
 * Request parameters for submitPrimaryClaim operation in FHIRClaimApi.
 * @export
 * @interface FHIRClaimApiSubmitPrimaryClaimRequest
 */
export interface FHIRClaimApiSubmitPrimaryClaimRequest {
    /**
     * 
     * @type {PrimaryClaimSubmitRequest}
     * @memberof FHIRClaimApiSubmitPrimaryClaim
     */
    readonly primaryClaimSubmitRequest: PrimaryClaimSubmitRequest
}

/**
 * Request parameters for submitSecondaryClaim operation in FHIRClaimApi.
 * @export
 * @interface FHIRClaimApiSubmitSecondaryClaimRequest
 */
export interface FHIRClaimApiSubmitSecondaryClaimRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRClaimApiSubmitSecondaryClaim
     */
    readonly claimId: string

    /**
     * 
     * @type {SecondaryClaimSubmitRequest}
     * @memberof FHIRClaimApiSubmitSecondaryClaim
     */
    readonly secondaryClaimSubmitRequest: SecondaryClaimSubmitRequest
}

/**
 * Request parameters for validatePostPayment operation in FHIRClaimApi.
 * @export
 * @interface FHIRClaimApiValidatePostPaymentRequest
 */
export interface FHIRClaimApiValidatePostPaymentRequest {
    /**
     * 
     * @type {ClaimSearch}
     * @memberof FHIRClaimApiValidatePostPayment
     */
    readonly claimSearch: ClaimSearch
}

/**
 * Request parameters for voidClaim operation in FHIRClaimApi.
 * @export
 * @interface FHIRClaimApiVoidClaimRequest
 */
export interface FHIRClaimApiVoidClaimRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRClaimApiVoidClaim
     */
    readonly claimId: string

    /**
     * 
     * @type {ClaimVoidRequest}
     * @memberof FHIRClaimApiVoidClaim
     */
    readonly claimVoidRequest: ClaimVoidRequest
}

/**
 * FHIRClaimApi - object-oriented interface
 * @export
 * @class FHIRClaimApi
 * @extends {BaseAPI}
 */
export class FHIRClaimApi extends BaseAPI implements FHIRClaimApiInterface {
    /**
     * 
     * @param {FHIRClaimApiCancelClaimBatchPostPaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApi
     */
    public cancelClaimBatchPostPayment(requestParameters: FHIRClaimApiCancelClaimBatchPostPaymentRequest, options?: RawAxiosRequestConfig) {
        return FHIRClaimApiFp(this.configuration).cancelClaimBatchPostPayment(requestParameters.batchId, requestParameters.reason, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * post payment for claims
     * @summary post payment for claims
     * @param {FHIRClaimApiCreateClaimBatchPostPaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApi
     */
    public createClaimBatchPostPayment(requestParameters: FHIRClaimApiCreateClaimBatchPostPaymentRequest, options?: RawAxiosRequestConfig) {
        return FHIRClaimApiFp(this.configuration).createClaimBatchPostPayment(requestParameters.batchClaimPostPaymentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete the primary claim in draft state
     * @summary delete the primary claim in draft state
     * @param {FHIRClaimApiDeleteClaimRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApi
     */
    public deleteClaim(requestParameters: FHIRClaimApiDeleteClaimRequest, options?: RawAxiosRequestConfig) {
        return FHIRClaimApiFp(this.configuration).deleteClaim(requestParameters.claimId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete post payment draft
     * @summary Delete post payment draft
     * @param {FHIRClaimApiDeletePostPaymentDraftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApi
     */
    public deletePostPaymentDraft(requestParameters: FHIRClaimApiDeletePostPaymentDraftRequest, options?: RawAxiosRequestConfig) {
        return FHIRClaimApiFp(this.configuration).deletePostPaymentDraft(requestParameters.claimId, requestParameters.claimResponseDraftDelete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate patient control number for the claim filing
     * @summary Generate patient control number for the claim filing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApi
     */
    public generateClaimPatientControlNumber(options?: RawAxiosRequestConfig) {
        return FHIRClaimApiFp(this.configuration).generateClaimPatientControlNumber(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get claim by claim id
     * @summary Get a claim by claim id
     * @param {FHIRClaimApiGetClaimRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApi
     */
    public getClaim(requestParameters: FHIRClaimApiGetClaimRequest, options?: RawAxiosRequestConfig) {
        return FHIRClaimApiFp(this.configuration).getClaim(requestParameters.claimId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get coverages for the claim filing
     * @summary Get coverages for the claim filing
     * @param {FHIRClaimApiGetClaimCoveragesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApi
     */
    public getClaimCoverages(requestParameters: FHIRClaimApiGetClaimCoveragesRequest = {}, options?: RawAxiosRequestConfig) {
        return FHIRClaimApiFp(this.configuration).getClaimCoverages(requestParameters.claimId, requestParameters.patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search claims
     * @summary Search claims
     * @param {FHIRClaimApiGetClaimsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApi
     */
    public getClaims(requestParameters: FHIRClaimApiGetClaimsRequest, options?: RawAxiosRequestConfig) {
        return FHIRClaimApiFp(this.configuration).getClaims(requestParameters.claimSearch, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get claims by patient id
     * @param {FHIRClaimApiGetClaimsByPatientIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApi
     */
    public getClaimsByPatientId(requestParameters: FHIRClaimApiGetClaimsByPatientIdRequest, options?: RawAxiosRequestConfig) {
        return FHIRClaimApiFp(this.configuration).getClaimsByPatientId(requestParameters.patientId, requestParameters.guarantorId, requestParameters.paymentReconciliationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get paginated payment reconciliations by claim id
     * @summary Get paginated payment reconciliations by claim id
     * @param {FHIRClaimApiGetPaymentReconciliationByClaimIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApi
     */
    public getPaymentReconciliationByClaimId(requestParameters: FHIRClaimApiGetPaymentReconciliationByClaimIdRequest, options?: RawAxiosRequestConfig) {
        return FHIRClaimApiFp(this.configuration).getPaymentReconciliationByClaimId(requestParameters.claimId, requestParameters.source, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get payment summary from ERA
     * @summary get payment summary from ERA
     * @param {FHIRClaimApiGetPaymentSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApi
     */
    public getPaymentSummary(requestParameters: FHIRClaimApiGetPaymentSummaryRequest, options?: RawAxiosRequestConfig) {
        return FHIRClaimApiFp(this.configuration).getPaymentSummary(requestParameters.claimId, requestParameters.claimResponseOperations, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get post payment draft
     * @summary Get post payment draft
     * @param {FHIRClaimApiGetPostPaymentDraftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApi
     */
    public getPostPaymentDraft(requestParameters: FHIRClaimApiGetPostPaymentDraftRequest, options?: RawAxiosRequestConfig) {
        return FHIRClaimApiFp(this.configuration).getPostPaymentDraft(requestParameters.claimId, requestParameters.operation, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get history of post payment for claims
     * @summary get history of post payment for claims
     * @param {FHIRClaimApiGetPostPaymentHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApi
     */
    public getPostPaymentHistory(requestParameters: FHIRClaimApiGetPostPaymentHistoryRequest, options?: RawAxiosRequestConfig) {
        return FHIRClaimApiFp(this.configuration).getPostPaymentHistory(requestParameters.batchPostPaymentSearchParams, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Patch a claim
     * @summary Patch a claim
     * @param {FHIRClaimApiPatchClaimRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApi
     */
    public patchClaim(requestParameters: FHIRClaimApiPatchClaimRequest, options?: RawAxiosRequestConfig) {
        return FHIRClaimApiFp(this.configuration).patchClaim(requestParameters.claimId, requestParameters.claimPatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Write off claims that have payment posted. Supports single claim, multiple claims, account-level, or patient-level write-offs.
     * @summary Write off claims
     * @param {FHIRClaimApiPostClaimWriteOffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApi
     */
    public postClaimWriteOff(requestParameters: FHIRClaimApiPostClaimWriteOffRequest, options?: RawAxiosRequestConfig) {
        return FHIRClaimApiFp(this.configuration).postClaimWriteOff(requestParameters.claimWriteOffRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create payment posting or update claim status
     * @summary Create a payment posting
     * @param {FHIRClaimApiPostPaymentForClaimRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApi
     */
    public postPaymentForClaim(requestParameters: FHIRClaimApiPostPaymentForClaimRequest, options?: RawAxiosRequestConfig) {
        return FHIRClaimApiFp(this.configuration).postPaymentForClaim(requestParameters.claimId, requestParameters.claimPaymentPostInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resubmit a denied or voided claim
     * @summary Resubmit a denied or voided claim
     * @param {FHIRClaimApiResubmitClaimRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApi
     */
    public resubmitClaim(requestParameters: FHIRClaimApiResubmitClaimRequest, options?: RawAxiosRequestConfig) {
        return FHIRClaimApiFp(this.configuration).resubmitClaim(requestParameters.claimId, requestParameters.claimResubmitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Save post payment draft
     * @summary Save post payment draft
     * @param {FHIRClaimApiSavePostPaymentDraftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApi
     */
    public savePostPaymentDraft(requestParameters: FHIRClaimApiSavePostPaymentDraftRequest, options?: RawAxiosRequestConfig) {
        return FHIRClaimApiFp(this.configuration).savePostPaymentDraft(requestParameters.claimId, requestParameters.claimResponseDraftSave, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * submit the primary claim
     * @summary submit the primary claim
     * @param {FHIRClaimApiSubmitPrimaryClaimRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApi
     */
    public submitPrimaryClaim(requestParameters: FHIRClaimApiSubmitPrimaryClaimRequest, options?: RawAxiosRequestConfig) {
        return FHIRClaimApiFp(this.configuration).submitPrimaryClaim(requestParameters.primaryClaimSubmitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Submit secondary claim
     * @summary Submit secondary claim
     * @param {FHIRClaimApiSubmitSecondaryClaimRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApi
     */
    public submitSecondaryClaim(requestParameters: FHIRClaimApiSubmitSecondaryClaimRequest, options?: RawAxiosRequestConfig) {
        return FHIRClaimApiFp(this.configuration).submitSecondaryClaim(requestParameters.claimId, requestParameters.secondaryClaimSubmitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * validate bulk post payment for claims
     * @summary validate bulk post payment for claims
     * @param {FHIRClaimApiValidatePostPaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApi
     */
    public validatePostPayment(requestParameters: FHIRClaimApiValidatePostPaymentRequest, options?: RawAxiosRequestConfig) {
        return FHIRClaimApiFp(this.configuration).validatePostPayment(requestParameters.claimSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Void a claim
     * @summary Void a claim
     * @param {FHIRClaimApiVoidClaimRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRClaimApi
     */
    public voidClaim(requestParameters: FHIRClaimApiVoidClaimRequest, options?: RawAxiosRequestConfig) {
        return FHIRClaimApiFp(this.configuration).voidClaim(requestParameters.claimId, requestParameters.claimVoidRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

